import React from "react";
import Linkify from "react-linkify";
import { useFieldLookup } from "../../../../hooks/useFieldLookup";
import { activityCommsTypesService, usersCachingService } from "../../../../services";
import { ActivitySkeleton } from "./ActivitySkeleton";
import { Flagged } from "./Flagged";
import { Typography, Divider } from "@material-ui/core";
import { DocumentDownload } from "./DocumentDownload";
import { useIsReady } from "../../../../hooks/useIsReadyHook";
export const Comms = ({ model, onToggle, disabled, onIsReady }) => {
    const { eventMeta, caseId, id } = model;
    const commsType = useFieldLookup(activityCommsTypesService, eventMeta.commsType);
    const createdByName = useFieldLookup(usersCachingService, model.createdBy);
    const isReady = commsType && createdByName;
    useIsReady(!!isReady, onIsReady);
    const componentDecorator = (href, text, key) => (React.createElement("a", { href: href, key: key, target: "_blank", rel: "noreferrer" }, text));
    return !isReady ? (React.createElement(ActivitySkeleton, null)) : (React.createElement("div", null,
        React.createElement(Flagged, { title: model.flagged ? "Mark as unflagged" : "Mark as flagged", isFlagged: model.flagged, onClick: () => onToggle(), disabled: disabled, hook: "activity-togglee-" + (model.flagged ? "true" : "false") }),
        React.createElement(Typography, null,
            React.createElement("strong", null, createdByName),
            " added a communication of type ",
            React.createElement("strong", null, commsType)),
        React.createElement(Divider, null),
        React.createElement(Typography, { variant: "body1", className: "ActivityNote", "data-test": "activity-title" },
            React.createElement("strong", null, eventMeta.commsSubject)),
        React.createElement(Typography, { variant: "body1", className: "ActivityNote", "data-test": "activity-body" },
            React.createElement(Linkify, { componentDecorator: componentDecorator }, eventMeta.commsBody)),
        eventMeta.fileName && (React.createElement("div", { className: "DocumentDownload", "data-test": "activity-attachment" },
            React.createElement(DocumentDownload, { caseId: caseId, id: id, label: eventMeta.fileName })))));
};
